var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reviews__reviews"},_vm._l((this.reviews),function(review,index){return (index < 3)?_c('Review',{key:review['ID waardering'],staticClass:"review",attrs:{"review":review}}):_vm._e()}))}
var staticRenderFns = []

export { render, staticRenderFns }